import React from 'react';
import { motion } from 'framer-motion';
const fadeVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      duration: 0.6
    }
  }
};
export function PartnersBadges() {
  return <motion.section initial="hidden" whileInView="visible" viewport={{
    once: true,
    margin: '-60px'
  }} variants={fadeVariants} className="py-10 md:py-14 px-5 md:px-8 bg-carbon border-y border-white/5" data-id="element-236">
      <div className="max-w-5xl mx-auto" data-id="element-237">
        <p className="text-gray-500 text-[11px] md:text-xs font-semibold tracking-[0.2em] uppercase text-center mb-6" data-id="element-238">
          Partners Certificados y Tecnología de Élite
        </p>
        <div className="flex flex-wrap items-center justify-center gap-3 md:gap-4" data-id="element-239">
          <div className="border border-white/10 rounded-lg px-4 py-2.5 md:px-5 md:py-3" data-id="element-240">
            <span className="text-gray-400 text-xs md:text-sm font-medium whitespace-nowrap" data-id="element-241">
              Meta Business Partner
            </span>
          </div>
          <div className="border border-white/10 rounded-lg px-4 py-2.5 md:px-5 md:py-3" data-id="element-242">
            <span className="text-gray-400 text-xs md:text-sm font-medium whitespace-nowrap" data-id="element-243">
              Google Ads
            </span>
          </div>
          <div className="border border-white/10 rounded-lg px-4 py-2.5 md:px-5 md:py-3" data-id="element-244">
            <span className="text-gray-400 text-xs md:text-sm font-medium whitespace-nowrap" data-id="element-245">
              Certified Digital Agency
            </span>
          </div>
          <div className="border border-white/10 rounded-lg px-4 py-2.5 md:px-5 md:py-3" data-id="element-246">
            <span className="text-gray-400 text-xs md:text-sm font-medium whitespace-nowrap" data-id="element-247">
              Shopify Experts
            </span>
          </div>
        </div>
      </div>
    </motion.section>;
}